export const SETUP_LINK_CIPHER = 'SETUP_LINK_CIPHER';
export const SHOW_SHARED_VIEW = 'SHOW_SHARED_VIEW';
export const UPDATE_APP_TYPE = 'UPDATE_APP_TYPE';
export const FETCH_LINK_DETAILS = 'FETCH_LINK_DETAILS';
export const SETUP_LINK_PASSWORD = 'SETUP_LINK_PASSWORD';
export const FETCH_LINK_RESTORE_INFO = 'FETCH_LINK_RESTORE_INFO';
export const FETCH_LINK_CONTENT_ITEMS = 'FETCH_LINK_CONTENT_ITEMS';
export const SORT_LINK_CONTENT_ITEMS = 'SORT_LINK_CONTENT_ITEMS';
